import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Box,
  Badge,
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import MoreIcon from '@mui/icons-material/MoreVert';
import { getProfile } from 'redux/actions/SettingsAction';
import { addMagicToken } from 'redux/actions/authAction';
import { getNotificationCount, getNotificationSeen } from 'redux/actions/UserNotification';
import { fetchRolesAndPermissions } from 'redux/actions/RolesAndPermissionsAction';
import { appBarStyle, appToolBarStyle } from './HeaderStyle';
import profile from 'assets/images/profileImg.svg';
import notification from 'assets/images/notificationIcon.svg';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import { companyDetails } from 'utils/companyDetails';
import { isSuperAdmin } from 'utils/jwtRole';

function Header(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(null);
  const [pageName, setPageName] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  let tableData = useSelector((state) => state?.userNotificationCount?.userNotificationCount?.data);
  const userProfileData = useSelector((state) => state?.auth?.userProfile?.data);
  const userId = localStorage.getItem('userId');
  const filterData = {
    id: '',
  };

  let user = {
    userId: userId,
  };

  useEffect(() => {
    dispatch(getProfile());
    dispatch(fetchRolesAndPermissions());
  }, []);

  useEffect(() => {
    const data = window.location.href;
    const paramsVal = data?.split('/')[3];
    if (paramsVal === 'notification') {
      tableData = { ...tableData, notificationsCount: 0 };
    } else {
      dispatch(getNotificationCount(filterData));
    }
    setPageName(paramsVal?.split('?')[0]);
  }, [location]);

  const handleOnError = (e) => {
    e.target.src = profile;
  };

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isPopoverMenuOpen = Boolean(popoverOpen);

  const handlePopoverMenuOpen = (event) => {
    setPopoverOpen(event.currentTarget);
  };

  const handlePopoverMenuClose = () => {
    setPopoverOpen(null);
  };

  const handleProfileMenuOpen = () => {
    window.location.replace('/settings');
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const onNotification = () => {
    dispatch(getNotificationSeen());
    window.location.replace('/notification');
  };

  const onHandleSwitch = () => {
    dispatch(addMagicToken());
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={onNotification}>
        <IconButton size="large" aria-label="show 17 new notifications" color="inherit">
          <Badge badgeContent={tableData?.notificationsCount} color="error">
            <img src={notification} alt="notification icon" />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <img
            className="width40 br100"
            src={userProfileData?.avatar?.url || profile}
            alt="profile"
            onError={handleOnError}
          />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const popoverMenuId = 'primary-switch-account-menu';
  const renderPopoverMenu = (
    <Menu
      anchorEl={popoverOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={popoverMenuId}
      keepMounted
      open={isPopoverMenuOpen}
      onClose={handlePopoverMenuClose}
    >
      <MenuItem className="bgWhite" onClick={() => onHandleSwitch()}>
        <Avatar alt="Admin" src="/static/images/avatar/1.jpg" className="width50" />
        <Typography variant={'body4'} className="pl10 fw500 colorBlack">
          {companyDetails?.companyName} B2C
        </Typography>
      </MenuItem>
    </Menu>
  );

  function generateGreeting(pageName) {
    switch (pageName) {
      case 'dashboard': {
        const currentTime = new Date();
        const hours = currentTime.getHours();

        if (hours >= 5 && hours < 12) {
          return 'Good Morning';
        } else if (hours >= 12 && hours < 17) {
          return 'Good Afternoon';
        } else {
          return 'Good Evening';
        }
      }
      case 'sub-vendor':
        return 'Sub Vendor';
      case 'citymanager':
        return 'City Manager';
      case 'regionaluser':
        return 'Regional User';
      case 'report':
        return 'Reports';
      case 'payment':
      case 'newPayment':
      case 'paymentdetails':
        return 'Settlement';

      default:
        return pageName.charAt(0).toUpperCase() + pageName.slice(1) || 'Hello';
    }
  }

  const greeting = generateGreeting(pageName);

  const userProfile = JSON?.parse(localStorage.getItem('user'));

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions,
  );
  const dashboardRoleEnum = roleAndPermissionEnum.dashboard;

  const accessForall = handlePermissions(roleAndPermissions, dashboardRoleEnum.moduleKey, {
    defaultAllAccess: dashboardRoleEnum.all,
  });

  const accessForSwitch = handlePermissions(roleAndPermissions, dashboardRoleEnum.moduleKey, {
    customAccess: dashboardRoleEnum.switchB2C,
  });

  const viewAccess = accessForSwitch;

  return (
    <div>
      <Box>
        <AppBar position="static" style={appBarStyle}>
          <Toolbar style={appToolBarStyle}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              {/* LEFT SECTION */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  minWidth: 0,
                }}
              >
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={props.handelOnlyOnMobile}
                  sx={{ display: { sm: 'none' } }}
                >
                  <MenuIcon />
                </IconButton>

                <Box sx={{ minWidth: 0 }}>
                  {pageName === 'dashboard' && (
                    <Typography variant="caption" color="text.secondary" noWrap>
                      Hi, {userProfile?.subRole}
                    </Typography>
                  )}
                  <Typography variant="subtitle1" fontWeight={600} noWrap>
                    {greeting}
                  </Typography>
                </Box>
              </Box>

              {/* RIGHT SECTION */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                {/* Mobile More Menu */}
                <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                  <IconButton
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <MoreIcon />
                  </IconButton>
                </Box>

                {/* Desktop Icons */}
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                  <IconButton onClick={onNotification} color="inherit">
                    <Badge badgeContent={tableData?.notificationsCount} color="error">
                      <img src={notification} alt="notification" />
                    </Badge>
                  </IconButton>

                  <IconButton onClick={handleProfileMenuOpen} color="inherit">
                    <img
                      className="img50 br100"
                      src={userProfileData?.avatar?.url || profile}
                      alt="profile"
                      onError={handleOnError}
                    />
                  </IconButton>
                </Box>

                {/* Company Switch (B2C portal) — QA: hide for tenant users; legacy single-tenant switch, super-admin only */}
                {isSuperAdmin() && viewAccess && (
                  <IconButton onClick={handlePopoverMenuOpen} color="inherit">
                    <Typography variant="body2" noWrap sx={{ maxWidth: 120, fontSize: '12px' }}>
                      {companyDetails?.companyName} B2B
                    </Typography>
                    {popoverOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
                  </IconButton>
                )}
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
        {renderPopoverMenu}
      </Box>
    </div>
  );
}

export default Header;
